import React, { useState } from 'react'
import { useGlobalContext } from '../../../Context/GlobalContext';
import { useParams } from 'react-router';
import Cookies from 'js-cookie';


const PersonalDetail = () => {


    const { id } = useParams();
    console.log(id)
    const [isLoading, setIsLoading] = useState(false);

    const { baseUrl, selectedStaff, openToast } = useGlobalContext()
    const [isEditable, setIsEditable] = useState(false);

    const [inputValue, setInputValue] = useState(selectedStaff?.staffDetails?.BankDetails?.bank_name);


    const [inputValue1, setInputValue1] = useState(selectedStaff?.staffDetails?.BankDetails?.ifsc_code);

    const [inputValue2, setInputValue2] = useState("--");

    const [inputValue3, setInputValue3] = useState("--");

    const [inputValue4, setInputValue4] = useState(selectedStaff?.staffDetails?.BankDetails?.account_number);

    const [inputValue5, setInputValue5] = useState(selectedStaff?.staffDetails?.BankDetails?.branch_name);


    const [isEditable6, setIsEditable6] = useState(false);
    const [inputValue6, setInputValue6] = useState(selectedStaff?.staffDetails?.UpiDetails?.UpiId);

    const [accountHolderName, setAccountHolderName] = useState(selectedStaff?.staffDetails?.BankDetails?.holder_name || "");
    const [accountStatus, setAccountStatus] = useState(selectedStaff?.staffDetails?.BankDetails?.status || "ACTIVE");



    // Function to toggle between editable and readonly mode
    const handleEditClick = async (e) => {

        e.preventDefault();
        if (isEditable) {
            setIsLoading(true);
            try {
                const response = await fetch(baseUrl + "bank-details/" + selectedStaff.staffDetails.id, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
                    },
                    body: JSON.stringify({
                        bank_name: inputValue,
                        account_number: inputValue4,
                        branch_name: inputValue5,
                        ifsc_code: inputValue1,
                        holder_name: accountHolderName,
                        status: accountStatus
                    })
                });
                // const resultIssues = await response.json();
                const result = await response.json();
                // console.log(resultIssues)
                if (response.status === 201) {
                    console.log(result.data);
                    openToast("Bank Details Added Successfully", "success");
                }
                else {
                    openToast(result.details || "error");
                }
            } catch (error) {
                console.error("Error submitting bank details:", error);
                openToast("An error occurred while adding bank details", "error");
            }
            finally {
                setIsLoading(false);
            }
        }

        setIsEditable(!isEditable); // Toggle editable state
    };

    const handleEditClick2 = async () => {
        if (isEditable6) {
            setIsLoading(true);
            try {
                const response = await fetch(baseUrl + "upi-details", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
                    },
                    body: JSON.stringify({
                        staffId: selectedStaff.staffDetails.id,
                        UpiId: inputValue6
                    })
                });

                if (response.status === 200) {
                    openToast("Upi Details Added Successfully", "success");
                }
                else {
                    openToast("An error occurred while adding Upi details", "error");
                }
            } catch (error) {
                console.error("Error submitting bank details:", error);
                openToast("An error occurred while adding Upi details", "error");
            } finally {
                setIsLoading(false);
            }
        }
        setIsEditable6(!isEditable6); // Toggle editable state
    };




    const handleInputChange = (e) => {
        setInputValue(e.target.value); // Update the value of input field
    };

    // second input value
    const handleInputChange1 = (e) => {
        setInputValue1(e.target.value); // Update the value of input field
    };
    //   second input value

    // third input value
    const handleInputChange2 = (e) => {
        setInputValue2(e.target.value); // Update the value of input field
    };

    // third input value

    // found input value
    const handleInputChange3 = (e) => {
        setInputValue3(e.target.value); // Update the value of input field
    };

    // four input value

    // five input value
    const handleInputChange4 = (e) => {
        setInputValue4(e.target.value); // Update the value of input field
    };
    // five input value

    // six input value
    const handleInputChange5 = (e) => {
        setInputValue5(e.target.value); // Update the value of input field
    };
    // six input value


    // upi details input value
    const handleInputChange6 = (e) => {
        setInputValue6(e.target.value); // Update the value of input field
    };
    // upi detals input value
    const handleHolderName = (e) => {
        setAccountHolderName(e.target.value); // Update the value of input field
    };
    const handleAccountStatus = (e) => {
        setAccountStatus(e.target.value); // Update the value of input field
    };


    return (
        <>
            <div className='relative flex flex-col xl:pt-[30px] pb-[30px] w-full'>

                <div className="top-0 flex justify-between items-center bg-white p-[30px] pt-0 pr-0 xl:pr-[0px] pb-[10px] pl-[0] w-[100%]">
                    <h3 className="bg-[#fff] shadow-cs pt-[10px] pb-[10px] pl-[14px] rounded-md w-full font-medium">Banking/Upi Details</h3>
                </div>


                <div className='top-0 flex justify-between items-center bg-white pr-0 xl:pr-[0px] pb-[10px] pl-[0] w-[100%]'>
                    <h3 className='bg-[#fff] pt-[15px] font-medium'>Bank Details</h3>
                    {/* <button className='second-btn'>Update Details</button> */}
                </div>

                <form className='border-1 shadow-md m-auto p-[12px] xl:p-[24px] border rounded-md w-[100%] xl:w-[100%]' onSubmit={handleEditClick}>
                    <div className='flex xl:flex-row flex-col justify-between gap-[10px] mb-[6px] xl:mb-4 w-[100%]'>
                        <div className='w-[100%] xl:w-[48%] 2xl:w-[48%]'>
                            <label className='text-[14px]'>Name of Bank</label><br />
                            <input
                                type="text"
                                value={inputValue}
                                onChange={handleInputChange}
                                readOnly={!isEditable} // Input readOnly rahega jab tak isEditable false hai
                                style={{
                                    boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                                }}
                                className='border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none'
                                required />
                        </div>

                        <div className='w-[100%] xl:w-[48%] 2xl:w-[48%]'>
                            <label className='text-[14px]'>IFSC Code</label><br />
                            <input
                                type="text"
                                value={inputValue1}
                                onChange={handleInputChange1}
                                readOnly={!isEditable}
                                style={{
                                    boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                                }}
                                className='border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none'
                                required />
                        </div>




                    </div>

                    <div className='flex xl:flex-row flex-col justify-between gap-[10px] mb-[6px] xl:mb-4 w-[100%]'>

                        <div className='w-[100%] xl:w-[48%] 2xl:w-[48%]'>
                            <label className='text-[14px]'>Account Number</label><br />
                            <input
                                type="text"
                                value={inputValue4}
                                onChange={handleInputChange4}
                                readOnly={!isEditable}
                                style={{
                                    boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                                }}
                                className='border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none'
                                required />
                        </div>

                        <div className='w-[100%] xl:w-[48%] 2xl:w-[48%]'>
                            <label className='text-[14px]'>Branch Name</label><br />
                            <input
                                type="text"
                                value={inputValue5}
                                onChange={handleInputChange5}
                                readOnly={!isEditable}
                                style={{
                                    boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                                }}
                                className='border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none'
                                required />
                        </div>



                    </div>

                    <div className='flex xl:flex-row flex-col justify-between gap-[10px] mb-[6px] xl:mb-4 w-[100%]'>

                        <div className='w-[100%] xl:w-[48%] 2xl:w-[48%]'>
                            <label className='text-[14px]'>Account Holder Name</label><br />
                            <input
                                type="text"
                                value={accountHolderName}
                                onChange={handleHolderName}
                                readOnly={!isEditable}
                                style={{
                                    boxShadow: isEditable ? "0px 0px 5px #dfdcdc" : ""
                                }}
                                className='border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none'
                                required />
                        </div>
                        <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
                            <label className="text-[14px]">Account Status</label>
                            <br />
                            <select
                                disabled={!isEditable}
                                value={accountStatus}
                                onChange={(e) => {
                                    setAccountStatus(e.target.value);
                                }}
                                className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none set-input-focus shadow-cs"
                            >
                                <option selected value={"ACTIVE"}>
                                    Active
                                </option>
                                <option value={"INACTIVE"}>
                                    Inactive
                                </option>
                            </select>
                        </div>
                    </div>







                    <div className='flex justify-end mt-4 p-3'>

                        <div className='flex items-center gap-[20px]'>
                            <button disabled={isLoading} type='button' className={'second-btn ' + (isLoading && 'opacity-50 cursor-not-allowed')} onClick={handleEditClick}>
                                {isEditable ? "Save" : "Edit"}
                            </button>

                        </div>

                    </div>




                </form>



                <h2 className='bg-[#fff] mt-[20px] pt-[10px] pb-[10px] rounded-lg font-medium'>Add UPI Details</h2>
                <form className='border-1 shadow-md m-auto p-[12px] xl:p-[24px] border rounded-md w-[100%] xl:w-[100%]' >
                    <div className='flex xl:flex-row flex-col justify-between gap-[10px] mb-[6px] xl:mb-4 w-[100%]'>
                        <div className='w-[100%] xl:w-[48%] 2xl:w-[48%]'>
                            <label className='text-[14px]'>UPI Details</label><br />
                            <input
                                type="text"
                                value={inputValue6}
                                onChange={handleInputChange6}
                                readOnly={!isEditable6} // Input readOnly rahega jab tak isEditable false hai
                                style={{
                                    boxShadow: isEditable6 ? "0px 0px 5px #dfdcdc" : ""
                                }}
                                className='border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none'
                            />
                        </div>




                    </div>

                    <div className='flex justify-end mt-4 p-3'>

                        <div className='flex items-center gap-[20px]'>
                            <button disabled={isLoading} type='button' className={'second-btn ' + (isLoading && 'opacity-50 cursor-not-allowed')} onClick={handleEditClick2}>
                                {isEditable6 ? "Save" : "Edit"}
                            </button>

                        </div>

                    </div>
                </form>
            </div>
        </>
    )
}

export default PersonalDetail;

